/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
// 是否关联
export const RELATED_TYPE = {
  0: { label: '未关联', value: '0' },
  1: { label: '已关联', value: '1' }
};
